/* ============================================================
   JE PEUX — Quiz (vanilla)
   Porta o QuizApp React (src/components/quiz/*) para DOM puro.
   Dados em /assets/quiz-questions.json, quiz-matrix.json,
   quiz-catalog.json. Lógica de match idêntica ao matchProfile.ts.
   ============================================================ */

(function () {
  var root = document.querySelector('[data-quiz-root]');
  if (!root) return;

  var state = {
    questions: [],
    matrix: [],
    catalog: { products: {}, kits: {} },
    currentIndex: 0,
    answers: {},
    finished: false,
  };

  function fetchJSON(url) {
    return fetch(url, { credentials: 'same-origin' }).then(function (r) {
      if (!r.ok) throw new Error('Failed to load ' + url);
      return r.json();
    });
  }

  function escapeHTML(value) {
    if (value == null) return '';
    return String(value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function formatBRL(reais) {
    return reais.toLocaleString('pt-BR', {
      style: 'currency',
      currency: 'BRL',
      minimumFractionDigits: 2,
    });
  }

  function matchProfile(matrix, answers) {
    for (var i = 0; i < matrix.length; i++) {
      var entry = matrix[i];
      var keys = Object.keys(entry.match);
      var allMatch = keys.every(function (key) {
        return answers[key] === entry.match[key];
      });
      if (allMatch) return entry;
    }
    return matrix[matrix.length - 1];
  }

  function render() {
    if (state.finished) {
      renderResult();
    } else {
      renderQuestion();
    }
  }

  function renderQuestion() {
    var question = state.questions[state.currentIndex];
    if (!question) return;
    var total = state.questions.length;
    var progress = ((state.currentIndex + 1) / total) * 100;
    var currentAnswer = state.answers[question.id];
    var canGoBack = state.currentIndex > 0;

    var optionsHTML = question.options
      .map(function (option) {
        var selected = currentAnswer === option.value;
        return (
          '<li>' +
          '<button type="button" class="quiz-option' +
          (selected ? ' is-selected' : '') +
          '" data-quiz-select="' +
          escapeHTML(option.value) +
          '" aria-pressed="' +
          (selected ? 'true' : 'false') +
          '">' +
          '<span class="quiz-option__emoji" aria-hidden="true">' +
          escapeHTML(option.emoji) +
          '</span>' +
          '<span class="quiz-option__body">' +
          '<span class="quiz-option__title">' +
          escapeHTML(option.title) +
          '</span>' +
          '<span class="quiz-option__description">' +
          escapeHTML(option.description) +
          '</span>' +
          '</span>' +
          '</button>' +
          '</li>'
        );
      })
      .join('');

    root.innerHTML =
      '<div class="quiz-step">' +
      '<div class="quiz-progress" role="progressbar" aria-valuemin="0" aria-valuemax="100" aria-valuenow="' +
      Math.round(progress) +
      '">' +
      '<div class="quiz-progress__bar" style="width:' +
      progress +
      '%"></div>' +
      '</div>' +
      '<p class="eyebrow quiz-step__eyebrow">' +
      escapeHTML(question.progressLabel) +
      '</p>' +
      '<h2 class="quiz-step__heading">' +
      escapeHTML(question.label) +
      '</h2>' +
      '<ul class="quiz-options" role="list">' +
      optionsHTML +
      '</ul>' +
      (canGoBack
        ? '<div class="quiz-step__nav"><button type="button" class="btn btn--link" data-quiz-back>← Voltar</button></div>'
        : '') +
      '</div>';
  }

  function renderResult() {
    var profile = matchProfile(state.matrix, state.answers);
    var catalog = state.catalog;

    var kitCards = (profile.kitSlugs || [])
      .map(function (slug) {
        return catalog.kits[slug];
      })
      .filter(Boolean);

    var productCards = (profile.productSlugs || [])
      .map(function (slug) {
        return catalog.products[slug];
      })
      .filter(Boolean);

    var items = kitCards.concat(productCards).slice(0, 4);
    var primaryKit = profile.primaryKitSlug ? catalog.kits[profile.primaryKitSlug] : null;

    var itemsHTML = items
      .map(function (item) {
        var isKit = item.type === 'kit';
        var badgeHTML = isKit && item.badge
          ? '<span class="quiz-card__badge">' + escapeHTML(item.badge) + '</span>'
          : '';
        var priceReais = (item.price || 0) / 100;
        return (
          '<a class="quiz-card quiz-card--' +
          escapeHTML(item.line) +
          '" href="' +
          escapeHTML(item.url) +
          '">' +
          '<div class="quiz-card__media" aria-hidden="true">' +
          badgeHTML +
          '</div>' +
          '<div class="quiz-card__body">' +
          '<p class="eyebrow quiz-card__eyebrow">' +
          escapeHTML(item.eyebrow) +
          '</p>' +
          '<h3 class="quiz-card__title">' +
          escapeHTML(item.name) +
          '</h3>' +
          '<p class="quiz-card__price">' +
          formatBRL(priceReais) +
          '</p>' +
          '<p class="quiz-card__cta">' +
          (isKit ? 'Ver kit →' : 'Ver produto →') +
          '</p>' +
          '</div>' +
          '</a>'
        );
      })
      .join('');

    var primaryCTA = primaryKit
      ? '<a class="btn btn--primary btn--lg" href="' +
        escapeHTML(primaryKit.url) +
        '">Conhecer ' +
        escapeHTML(primaryKit.name) +
        ' →</a>'
      : '';

    root.innerHTML =
      '<div class="quiz-result">' +
      '<div class="quiz-result__header">' +
      '<p class="eyebrow quiz-result__eyebrow">SUA RECOMENDAÇÃO</p>' +
      '<h2 class="quiz-result__heading">' +
      escapeHTML(profile.profileName) +
      '</h2>' +
      '<p class="quiz-result__rationale">' +
      escapeHTML(profile.rationale) +
      '</p>' +
      '</div>' +
      (items.length
        ? '<div class="quiz-result__grid" data-item-count="' +
          items.length +
          '">' +
          itemsHTML +
          '</div>'
        : '') +
      '<div class="quiz-result__actions">' +
      primaryCTA +
      '<button type="button" class="btn btn--link" data-quiz-restart>Refazer o quiz</button>' +
      '</div>' +
      '</div>';
  }

  function handleSelect(value) {
    var question = state.questions[state.currentIndex];
    if (!question) return;
    state.answers = Object.assign({}, state.answers, defineAnswer(question.id, value));
    if (state.currentIndex < state.questions.length - 1) {
      state.currentIndex += 1;
    } else {
      state.finished = true;
    }
    render();
    scrollToRoot();
  }

  function defineAnswer(id, value) {
    var patch = {};
    patch[id] = value;
    return patch;
  }

  function handleBack() {
    if (state.currentIndex > 0) {
      state.currentIndex -= 1;
      render();
    }
  }

  function handleRestart() {
    state.currentIndex = 0;
    state.answers = {};
    state.finished = false;
    render();
    scrollToRoot();
  }

  function scrollToRoot() {
    if (typeof root.scrollIntoView === 'function') {
      root.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }

  root.addEventListener('click', function (event) {
    var target = event.target.closest('[data-quiz-select], [data-quiz-back], [data-quiz-restart]');
    if (!target) return;
    if (target.hasAttribute('data-quiz-select')) {
      handleSelect(target.getAttribute('data-quiz-select'));
    } else if (target.hasAttribute('data-quiz-back')) {
      handleBack();
    } else if (target.hasAttribute('data-quiz-restart')) {
      handleRestart();
    }
  });

  var questionsUrl = root.getAttribute('data-questions-url');
  var matrixUrl = root.getAttribute('data-matrix-url');
  var catalogUrl = root.getAttribute('data-catalog-url');

  Promise.all([fetchJSON(questionsUrl), fetchJSON(matrixUrl), fetchJSON(catalogUrl)])
    .then(function (results) {
      state.questions = results[0];
      state.matrix = results[1];
      state.catalog = results[2];
      render();
    })
    .catch(function (error) {
      root.innerHTML =
        '<div class="quiz__error">Não foi possível carregar o quiz. Recarregue a página.</div>';
      if (window.console) console.error(error);
    });
})();
